import { render } from "./StarOutline.vue?vue&type=template&id=585f4fd0"
import script from "./StarOutline.vue?vue&type=script&lang=js"
export * from "./StarOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__